import React from 'react';
import ReactDOM from 'react-dom';

import SignupProcess from './signup/signup';
//import FrontTester from './fronttester/FrontTester';

window.document.addEventListener( 'DOMContentLoaded', () => {
	var main = window.document.getElementById( 'signup_process' );
	if( main ) { 
		var code = main.getAttribute( 'js-code' );
		ReactDOM.render(
			<SignupProcess Code={ code }/>,
			main
		);
	}

	// main = window.document.getElementById( 'labtestform' );
	// if( ! main ) { return; }
	// try {
	// 	code = JSON.parse( main.getAttribute( 'js-data' ) );
	// } catch( e ) {
	// 	return;
	// }
	// ReactDOM.render(
	// 	<FrontTester data={ code }/>,
	// 	main
	// );
} );
